export const reviewWorkspace = {
  me: {
    displayName: "Shashank Kaul",
    email: "kaul.shashank@gmail.com",
    role: "OrganizationAdministrator",
  },
  devices: [
    { deviceId: "PIRDY-00000002", name: "Reception Display", profileId: "PIRDY_C3_28_TOUCH", groupId: "front", desiredDisplayOn: true },
    { deviceId: "PIRDY-00000003", name: "Aisle 3 Display", profileId: "PIRDY_C3_28_TOUCH", groupId: "front", desiredDisplayOn: true },
    { deviceId: "PIRDY-00000004", name: "Checkout Display", profileId: "PIRDY_C3_28_NOTOUCH", groupId: "checkout", desiredDisplayOn: false },
  ],
  statuses: [
    { deviceId: "PIRDY-00000002", controlConnected: true, state: "Up to date", lastSeen: "Just now" },
    { deviceId: "PIRDY-00000003", controlConnected: true, state: "Updating", lastSeen: "2 minutes ago" },
    { deviceId: "PIRDY-00000004", controlConnected: false, state: "Waiting to update", lastSeen: "Yesterday" },
  ],
  groups: [
    { groupId: "front", name: "Front of Store", siteId: "retail-floor", displayOn: true, members: ["PIRDY-00000002", "PIRDY-00000003"] },
    { groupId: "checkout", name: "Checkout", siteId: "retail-floor", displayOn: false, members: ["PIRDY-00000004"] },
  ],
  sites: [
    { siteId: "retail-floor", name: "Main Store" },
  ],
  playlists: [
    { playlistId: "classic", name: "Classic", itemCount: 2, updatedAt: "Today" },
    { playlistId: "weekend", name: "Weekend Offers", itemCount: 3, updatedAt: "Yesterday" },
  ],
  content: [
    { id: "summer", assetId: "summer", name: "Summer Offer", width: 320, height: 240, sourceWidth: 1920, sourceHeight: 1920, orientation: 2, playbackMode: 1, color: "#7b1735" },
    { id: "weekend", assetId: "weekend", name: "Weekend Specials", width: 900, height: 240, sourceWidth: 900, sourceHeight: 240, orientation: 2, playbackMode: 2, color: "#e4aa24" },
    { id: "menu", assetId: "menu", name: "Tall Menu", width: 320, height: 1920, sourceWidth: 320, sourceHeight: 1920, orientation: 2, playbackMode: 3, color: "#155b9a" },
  ],
};

export const reviewBilling = {
  hostedPaymentsAvailable: false,
  paymentAvailabilityMessage: "Secure payment is not active. No charge can be attempted.",
  state: "Final",
  generatedAtUtc: "2026-09-01T00:05:00Z",
  summary: {
    organizationId: "review-organization",
    planName: "Standard",
    billingCycle: "Monthly",
    currentPeriod: { startUtc: "2026-09-01T00:00:00Z", endExclusiveUtc: "2026-10-01T00:00:00Z" },
    billableDeviceQuantity: 3,
    commercialSubtotal: { amount: 149, currency: "INR" },
    discount: { amount: 0, currency: "INR" },
    tax: { amount: 26.82, currency: "INR" },
    balance: { amount: 175.82, currency: "INR" },
    paymentStatus: "Due",
    nextPaymentDueUtc: "2026-09-15T00:00:00Z",
    usage: [],
  },
  invoices: [
    { invoiceId: "invoice-21", invoiceNumber: "PIRDY-2026-000021", billingPeriod: { startUtc: "2026-09-01T00:00:00Z", endExclusiveUtc: "2026-10-01T00:00:00Z" }, issuedAtUtc: "2026-09-01T00:00:00Z", dueAtUtc: "2026-09-15T00:00:00Z", status: "Issued", subtotal: { amount: 149, currency: "INR" }, discount: { amount: 0, currency: "INR" }, tax: { amount: 26.82, currency: "INR" }, total: { amount: 175.82, currency: "INR" }, outstanding: { amount: 175.82, currency: "INR" }, documentAvailable: true },
    { invoiceId: "invoice-20", invoiceNumber: "PIRDY-2026-000020", billingPeriod: { startUtc: "2026-08-01T00:00:00Z", endExclusiveUtc: "2026-09-01T00:00:00Z" }, issuedAtUtc: "2026-08-01T00:00:00Z", dueAtUtc: "2026-08-15T00:00:00Z", status: "Paid", subtotal: { amount: 149, currency: "INR" }, discount: { amount: 0, currency: "INR" }, tax: { amount: 26.82, currency: "INR" }, total: { amount: 175.82, currency: "INR" }, outstanding: { amount: 0, currency: "INR" }, documentAvailable: true },
  ],
  payments: [],
};
